import angular from 'angular';
import './cartModule.js';
import {default as cart} from './views/cart.html';
import {default as version} from './views/version.html';

angular.module('cart').config(['$routeProvider', function($routeProvider) {
    $routeProvider
        .when('/:locale/cart', {
            template: cart,
            controller: 'CartCtrl'
        })
        .when('/:locale/mysite/cart', {
            template: cart,
            controller: 'CartCtrl'
        })
        .when('/version', {
            template: version,
            controller: 'VersionCtrl'
        })
        .otherwise({
            template: cart,
            controller: 'CartCtrl'
        });
}]);

